/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  SessionDto
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




export const sessionControllerGetOrCreateSession = (
    
 ) => {
      
      
      return customFetcher<SessionDto>(
      {url: `/session`, method: 'PUT'
    },
      );
    }
  


export const getSessionControllerGetOrCreateSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>, TError,void, TContext> => {

const mutationKey = ['sessionControllerGetOrCreateSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>, void> = () => {
          

          return  sessionControllerGetOrCreateSession()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerGetOrCreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>>
    
    export type SessionControllerGetOrCreateSessionMutationError = unknown

    export const useSessionControllerGetOrCreateSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerGetOrCreateSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSessionControllerGetOrCreateSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    